import axios from "axios";
import config from "../environment/config";

const API_URL = `${config.API_URL}api/seo-user`;

export const checkEmail = async (email) => {
  try {
    const payload = {
      email: email,
      actionType: "INSERT"
    };

    const response = await axios.post(API_URL, payload);
    return response.data; // If no error → email is NOT registered
  } catch (error) {
    if (error?.response?.data?.errorKey === "emailexists") {
      return true; // email already exists
    }
    console.error("Check email failed:", error);
    return false;
  }
};
